var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import List from "../List";
const Grid = (_a) => {
    var { className } = _a, props = __rest(_a, ["className"]);
    const classes = classNames("gerudo-grid", className);
    return React.createElement(List, Object.assign({ className: classes }, props));
};
Grid.defaultProps = {};
Grid.propTypes = {
    className: PropTypes.string,
    items: PropTypes.array.isRequired,
};
export default Grid;
export { Grid };
//# sourceMappingURL=index.js.map